import { AnyAction, Dispatch } from 'redux';
import { ApiStatuses } from '../../../../global/models/api-model';
import { Group, GroupsActionTypes, GroupsState } from './groups-model';


const InitialState: GroupsState = {
	groups: [],
	groupsLoaded: false,
    currentGroup: null,
    adminAddStatus: ApiStatuses.None,
};


export const groupsReducer = (state = InitialState, action: AnyAction): GroupsState => {
	switch (action.type) {
        case GroupsActionTypes.SET_GROUPS:
            return {
                ...state,
                groups: action.payload,
                groupsLoaded: true,
                currentGroup: action.payload.length === 1 ? action.payload[0] : state.currentGroup,
            };
        case GroupsActionTypes.SET_CURRENT_GROUP:
            return {
                ...state,
                currentGroup: action.payload,
            };
        case GroupsActionTypes.ADD_ADMIN_STATUS:
            return {
                ...state,
                adminAddStatus: action.payload,
            };
        case GroupsActionTypes.CLEAR:
            return InitialState;

		default: return state;
	}
};

export const setGroups = (groups: Group[]): AnyAction => {
    return {
        type: GroupsActionTypes.SET_GROUPS,
        payload: groups,
    };
};

export const dispatchSetGroups = (dispatch: Dispatch<any>) => (response) => {
    dispatch(setGroups(response.data));
};

export const setCurrentGroup = (group: Group): AnyAction => {
    return {
        type: GroupsActionTypes.SET_CURRENT_GROUP,
        payload: group,
    };
};

export const setAddAdminStatus = (status: ApiStatuses): AnyAction => {
    return {
        type: GroupsActionTypes.ADD_ADMIN_STATUS,
        payload: status,
    };
};

export const clearGroupState = () => {
    return {
        type: GroupsActionTypes.CLEAR,
    };
};